<mat-toolbar color="primary" class="app-toolbar">
  <button mat-icon-button aria-label="Toggle sidebar" (click)="toggleSidebar()">
    <mat-icon>menu</mat-icon>
  </button>

  <div class="toolbar-brand">
    <span class="brand-title">Vaggit Admin</span>
  </div>

  <span class="toolbar-spacer"></span>

  <ng-container *ngIf="!(isCompact$ | async)">
    <div class="toolbar-links">
      <a mat-icon-button routerLink="/dashboard"><mat-icon>dashboard</mat-icon></a>
      <a mat-icon-button routerLink="/property/rent/manage"><mat-icon>home_work</mat-icon></a>
      <a mat-icon-button routerLink="/users/all"><mat-icon>group</mat-icon></a>
    </div>
  </ng-container>

  <mat-menu #mobileMenu="matMenu">
    <button mat-menu-item routerLink="/dashboard">Dashboard</button>
    <button mat-menu-item routerLink="/property/rent/manage">Properties</button>
    <button mat-menu-item routerLink="/users/all">Users</button>
    <button mat-menu-item routerLink="/campaigns">Campaigns</button>
  </mat-menu>

  <div class="toolbar-user">
    <div mat-icon-button [matMenuTriggerFor]="userMenu" class="d-flex align-items-center cursor-pointer">
      <mat-icon>account_circle</mat-icon>

      <div class="user-info d-flex flex-column justify-content-center ml-2" *ngIf="!(isCompact$ | async)">
        <small class="user-profile-type mb-1">{{ currentUser?.role || 'ADMIN' }}</small>
        <h6 class="user-email mb-1">{{ currentUser?.username || 'Admin User' }}</h6>
      </div>
    </div>
  </div>

  <mat-menu #userMenu="matMenu">
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="goToMyProfile()">Profile</button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="logout()">Log out</button>
  </mat-menu>
</mat-toolbar>
